import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

// 公共路由
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/Login"),
    meta: { title: "登录" },
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    hidden: true,
    children: [
      {
        path: "/home",
        component: () => import("@/views/Home"),
        name: "home",
        hidden: false,
        redirect: "/viewpager",
        meta: {
          title: "首页",
          showCard: true,
          icon: require("@/assets/tarbar/home.png"),
          activeicon: require("@/assets/tarbar/home_active.png"),
        },
        children: [
          {
            path: "/viewpager",
            component: () => import("@/views/Home/Viewpager"),
            hidden: false,
            name: "viewpager",
            meta: {
              title: "轮播图管理",
              showCard: true,
              cardTitle: "轮播图管理",
              parent: "home",
            },
            redirect: "/pagerlist",
            children: [
              {
                path: "/pagerlist",
                component: () => import("@/views/Home/Viewpager/PagerList"),
                hidden: true,
                name: "pagerlist",
                meta: {
                  title: "轮播图列表",
                  showCard: true,
                  parent: "viewpager",
                  cardTitle: "轮播图列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/addpaper",
                component: () => import("@/views/Home/Viewpager/AddPaper"),
                hidden: true,
                name: "addpaper",
                meta: {
                  title: "轮播图",
                  showCard: true,
                  parent: "viewpager",
                  cardTitle: "轮播图",
                },
              },
            ],
          },
          {
            path: "/news",
            component: () => import("@/views/Home/News"),
            hidden: false,
            name: "news",
            meta: {
              title: "资讯列表",
              showCard: true,
              cardTitle: "资讯列表",
              parent: "home",
            },
            redirect: "/newslist",
            children: [
              {
                path: "/newslist",
                component: () => import("@/views/Home/News/NewsList"),
                hidden: true,
                name: "newslist",
                meta: {
                  title: "资讯列表",
                  showCard: true,
                  parent: "news",
                  cardTitle: "资讯列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/addNews",
                component: () => import("@/views/Home/News/AddNews"),
                hidden: true,
                name: "addNews",
                meta: {
                  title: "添加资讯",
                  showCard: true,
                  parent: "news",
                  cardTitle: "添加资讯",
                },
              },
            ],
          },
          {
            path: "/information",
            component: () => import("@/views/Home/Information"),
            hidden: false,
            name: "information",
            meta: {
              title: "消息公告管理",
              showCard: true,
              cardTitle: "消息公告管理",
              parent: "home",
            },
            redirect: "/informationlist",
            children: [
              {
                path: "/informationlist",
                component: () =>
                  import("@/views/Home/Information/InformationList"),
                hidden: true,
                name: "informationlist",
                meta: {
                  title: "消息公告列表",
                  showCard: true,
                  parent: "information",
                  cardTitle: "消息公告列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/addInformation",
                component: () =>
                  import("@/views/Home/Information/AddInformation"),
                hidden: true,
                name: "addInformation",
                meta: {
                  title: "管理消息公告",
                  showCard: true,
                  parent: "information",
                  cardTitle: "管理消息公告",
                },
              },
            ],
          },
        ],
      },

      {
        path: "/simulator",
        component: () => import("@/views/Simulator"),
        name: "simulator",
        hidden: false,
        redirect: "/rom",
        meta: {
          title: "模拟器管理",
          showCard: true,
          icon: require("@/assets/tarbar/home.png"),
          activeicon: require("@/assets/tarbar/home_active.png"),
        },
        children: [
          {
            path: "/rom",
            component: () => import("@/views/Simulator/rom"),
            hidden: false,
            name: "room",
            meta: {
              title: "rom管理",
              showCard: true,
              cardTitle: "rom管理",
              parent: "Simulator",
            },
            redirect: "/romlist",
            children: [
              {
                path: "/romlist",
                component: () => import("@/views/Simulator/rom/RomList"),
                hidden: true,
                name: "romlist",
                meta: {
                  title: "rom列表",
                  showCard: true,
                  parent: "romlist",
                  cardTitle: "rom列表",
                  breadcrumb: false,
                  hideTitle: true,
                },
              },
              {
                path: "/addRom",
                component: () => import("@/views/Simulator/rom/AddRom"),
                hidden: true,
                name: "addRom",
                meta: {
                  title: "rom",
                  showCard: true,
                  parent: "rom",
                  cardTitle: "rom",
                  hideTitle: true,
                },
              },
            ],
          },
        ],
      },

      {
        path: "/circle",
        component: () => import("@/views/Circle"),
        hidden: false,
        name: "circle",
        redirect: "/circlelist",
        meta: {
          title: "圈子管理",
          icon: require("@/assets/tarbar/circle.png"),
          activeicon: require("@/assets/tarbar/circle_active.png"),
          showCard: true,
        },
        children: [
          {
            path: "/circlelist",
            component: () => import("@/views/Circle/CircleList"),
            hidden: false,
            name: "circlelist",
            meta: {
              title: "圈子列表",
              showCard: true,
              cardTitle: "圈子列表",
              parent: "circle",
            },
          },
          {
            path: "/circledetails",
            component: () => import("@/views/Circle/CircleDetails"),
            hidden: true,
            name: "circledetails",
            meta: {
              title: "查看圈子详情",
              showCard: true,
              cardTitle: "查看圈子详情",
              parent: "circle",
            },
          },
          {
            path: "/commentList",
            component: () => import("@/views/Circle/CommentList"),
            hidden: false,
            name: "commentList",
            meta: {
              title: "评论管理",
              showCard: true,
              cardTitle: "评论管理",
              parent: "circle",
            },
          },
        ],
      },
      {
        path: "/shop",
        component: () => import("@/views/Shop"),
        hidden: false,
        name: "shop",
        redirect: "noRedirect",
        meta: {
          title: "商城管理",
          icon: require("@/assets/tarbar/shop.png"),
          activeicon: require("@/assets/tarbar/shop_active.png"),
          showCard: true,
          breadcrumb: false,
        },
        children: [
          {
            path: "/order",
            component: () => import("@/views/Shop/Order"),
            hidden: false,
            name: "order",
            meta: {
              title: "订单列表",
              showCard: true,
              cardTitle: "订单列表",
              parent: "shop",
            },
            redirect: "/orderlist",
            children: [
              {
                path: "/orderlist",
                component: () => import("@/views/Shop/Order/OrderList"),
                hidden: true,
                name: "orderlist",
                meta: {
                  title: "订单列表",
                  showCard: true,
                  parent: "order",
                  cardTitle: "订单列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/orderdetails",
                component: () => import("@/views/Shop/Order/OrderDetails"),
                hidden: true,
                name: "orderdetails",
                meta: {
                  title: "订单详情",
                  showCard: true,
                  parent: "order",
                  cardTitle: "订单详情",
                  breadcrumb: false,
                },
              },
            ],
          },
          {
            path: "/aftersale",
            component: () => import("@/views/Shop/AfterSale"),
            hidden: false,
            name: "aftersale",
            meta: {
              title: "售后管理",
              showCard: true,
              cardTitle: "售后管理",
              parent: "shop",
            },
            redirect: "/service",
            children: [
              {
                path: "/service",
                component: () => import("@/views/Shop/AfterSale/AfterList"),
                hidden: true,
                name: "service",
                meta: {
                  title: "售后管理",
                  showCard: true,
                  parent: "aftersale",
                  cardTitle: "售后管理",
                  breadcrumb: false,
                },
              },
            ],
          },
          {
            path: "/goods",
            component: () => import("@/views/Shop/Goods"),
            hidden: false,
            name: "Goods",
            meta: {
              title: "商品列表",
              showCard: true,
              cardTitle: "商品列表",
              parent: "shop",
            },
            redirect: "/goodslist",
            children: [
              {
                path: "/goodslist",
                component: () => import("@/views/Shop/Goods/GoodsList"),
                hidden: true,
                name: "GoodsList",
                meta: {
                  title: "商品列表",
                  showCard: true,
                  parent: "goods",
                  cardTitle: "商品列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/commodity",
                component: () => import("@/views/Shop/Goods/AddGoods"),
                hidden: true,
                name: "commodity",
                meta: {
                  title: "商品",
                  showCard: true,
                  parent: "goods",
                  cardTitle: "商品",
                },
              },
            ],
          },
          {
            path: "/goodsclassify",
            component: () => import("@/views/Shop/GoodsClassify"),
            hidden: false,
            name: "GoodsClassify",
            meta: {
              title: "商品分类",
              showCard: true,
              cardTitle: "商品分类",
              parent: "shop",
            },
            redirect: "/goodsclassify",
            children: [
              {
                path: "/goodsclassify",
                component: () =>
                  import("@/views/Shop/GoodsClassify/ClassifyList"),
                hidden: true,
                name: "ClassifyList",
                meta: {
                  title: "商品分类",
                  showCard: true,
                  parent: "goodsclassify",
                  cardTitle: "商品分类",
                  breadcrumb: false,
                },
              },
              {
                path: "/classify",
                component: () =>
                  import("@/views/Shop/GoodsClassify/AddClassify"),
                hidden: true,
                name: "classify",
                meta: {
                  title: "分类",
                  showCard: true,
                  parent: "goodsclassify",
                  cardTitle: "分类",
                },
              },
            ],
          },
        ],
      },
      {
        path: "/customer",
        component: () => import("@/views/Customer"),
        hidden: false,
        name: "customer",
        redirect: "/customerlist",
        meta: {
          title: "用户管理",
          icon: require("@/assets/tarbar/customer.png"),
          activeicon: require("@/assets/tarbar/customer_active.png"),
          showCard: true,
          breadcrumb: false,
        },
        children: [
          {
            path: "/customerlist",
            component: () => import("@/views/Customer/CustomerList"),
            hidden: false,
            name: "customerlist",
            meta: {
              title: "用户列表",
              showCard: true,
              cardTitle: "用户列表",
              parent: "customer",
            },
          },
          {
            path: "/logoutList",
            component: () => import("@/views/Customer/LogoutList"),
            hidden: false,
            name: "logoutList",
            meta: {
              title: "注销账户",
              showCard: true,
              cardTitle: "注销账户",
              parent: "customer",
            },
          },
        ],
      },
      {
        path: "/device",
        component: () => import("@/views/Device"),
        hidden: false,
        name: "device",
        redirect: "/devicelist",
        meta: {
          title: "设备管理",
          icon: require("@/assets/tarbar/device.png"),
          activeicon: require("@/assets/tarbar/device_active.png"),
          showCard: true,
          breadcrumb: false,
        },
        children: [
          {
            path: "/devicelist",
            component: () => import("@/views/Device/DeviceList"),
            hidden: false,
            name: "devicelist",
            meta: {
              title: "设备列表",
              showCard: true,
              cardTitle: "设备列表",
              parent: "device",
            },
          },
          {
            path: "/staffList",
            component: () => import("@/views/Device/StaffList"),
            hidden: false,
            name: "staffList",
            meta: {
              title: "质检员管理",
              showCard: true,
              cardTitle: "质检员管理",
              parent: "device",
            },
          },
          {
            path: "/activationList",
            component: () => import("@/views/Device/ActivationList"),
            hidden: false,
            name: "activationList",
            meta: {
              title: "设备激活码管理",
              showCard: true,
              cardTitle: "设备激活码管理",
              parent: "device",
            },
          },
          {
            path: "/codelist",
            component: () => import("@/views/Device/ActivationList/code"),
            hidden: true,
            name: "codelist",
            meta: {
              title: "设备激活码",
              showCard: true,
              cardTitle: "设备激活码",
              parent: "device",
            },
          },
        ],
      },
      // {
      //   path: "/resource",
      //   component: () => import("@/views/Resource"),
      //   hidden: false,
      //   name: "resource",
      //   redirect: "/gamelist",
      //   meta: {
      //     title: "资源管理",
      //     icon: require("@/assets/tarbar/resource.png"),
      //     activeicon: require("@/assets/tarbar/resource_active.png"),
      //     showCard: true,
      //     breadcrumb: false,
      //   },
      //   children: [

      //   ],
      // },
      {
        path: "/game",
        component: () => import("@/views/Game"),
        hidden: false,
        name: "game",
        redirect: "/gamelist",
        meta: {
          title: "游戏管理",
          icon: require("@/assets/tarbar/game.png"),
          activeicon: require("@/assets/tarbar/game_active.png"),
          showCard: true,
          breadcrumb: false,
        },
        children: [
          {
            path: "/gamelist",
            component: () => import("@/views/Resource/GameList"),
            hidden: false,
            name: "gamelist",
            meta: {
              title: "体感游戏",
              showCard: true,
              cardTitle: "体感游戏",
              parent: "resource",
            },
            children: [
              {
                path: "/music",
                component: () => import("@/views/Resource/Music"),
                hidden: true,
                name: "music",
                meta: {
                  title: "音乐资源",
                  showCard: true,
                  cardTitle: "音乐资源",
                  parent: "gamelist",
                },
              },
              {
                path: "/addmusic",
                component: () => import("@/views/Resource/Music/addMusic"),
                hidden: true,
                name: "addmusic",
                meta: {
                  title: "添加音乐",
                  showCard: true,
                  cardTitle: "添加音乐",
                  parent: "music",
                },
              },
              {
                path: "/background",
                component: () => import("@/views/Resource/Background"),
                hidden: true,
                name: "background",
                meta: {
                  title: "背景资源",
                  showCard: true,
                  cardTitle: "背景资源",
                  parent: "gamelist",
                },
              },
              {
                path: "/material",
                component: () => import("@/views/Resource/GameList/material"),
                hidden: true,
                name: "material",
                meta: {
                  title: "素材资源",
                  showCard: true,
                  cardTitle: "素材资源",
                  parent: "gamelist",
                },
              },
              {
                path: "/video",
                component: () => import("@/views/Resource/GameList/video"),
                hidden: true,
                name: "video",
                meta: {
                  title: "教程视频",
                  showCard: true,
                  cardTitle: "教程视频",
                  parent: "gamelist",
                },
              },
            ],
          },
          {
            path: "/minigame",
            component: () => import("@/views/Game/GameList"),
            hidden: false,
            name: "minigame",
            meta: {
              title: "H5小游戏",
              showCard: true,
              cardTitle: "H5小游戏",
              parent: "game",
            },
          },
          {
            path: "/addGame",
            component: () => import("@/views/Game/AddGame"),
            hidden: true,
            name: "addGame",
            meta: {
              title: "操作游戏",
              showCard: true,
              cardTitle: "操作游戏",
              parent: "game",
            },
          },
        ],
      },
      {
        path: "/setting",
        component: () => import("@/views/Setting"),
        hidden: false,
        name: "setting",
        redirect: "/agreement",
        meta: {
          title: "系统设置",
          icon: require("@/assets/tarbar/setting.png"),
          activeicon: require("@/assets/tarbar/setting_active.png"),
          showCard: true,
        },
        children: [
          {
            path: "/agreement",
            component: () => import("@/views/Setting/Agreement"),
            hidden: false,
            name: "agreement",
            meta: {
              title: "协议列表",
              showCard: true,
              cardTitle: "协议列表",
              parent: "setting",
            },
            redirect: "/agreementlist",
            children: [
              {
                path: "/agreementlist",
                component: () =>
                  import("@/views/Setting/Agreement/AgreementList"),
                hidden: true,
                name: "agreementlist",
                meta: {
                  title: "协议列表",
                  showCard: true,
                  parent: "setting",
                  cardTitle: "协议列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/newagreement",
                component: () =>
                  import("@/views/Setting/Agreement/NewAgreement"),
                hidden: true,
                name: "newagreement",
                meta: {
                  title: "协议",
                  showCard: true,
                  parent: "setting",
                  cardTitle: "协议",
                },
              },
            ],
          },
          {
            path: "/feedback",
            component: () => import("@/views/Setting/Feedback"),
            hidden: false,
            name: "feedback",
            meta: {
              title: "反馈列表",
              showCard: true,
              cardTitle: "反馈列表",
              parent: "setting",
            },
          },
          {
            path: "/versions",
            component: () => import("@/views/Setting/Versions"),
            hidden: false,
            name: "versions",
            meta: {
              title: "版本信息",
              showCard: true,
              cardTitle: "版本信息",
              parent: "setting",
            },
            redirect: "/versionslist",
            children: [
              {
                path: "/versionslist",
                component: () =>
                  import("@/views/Setting/Versions/VersionsList"),
                hidden: true,
                name: "versionslist",
                meta: {
                  title: "版本列表",
                  showCard: true,
                  parent: "versions",
                  cardTitle: "版本列表",
                  breadcrumb: false,
                },
              },
              {
                path: "/newversions",
                component: () => import("@/views/Setting/Versions/NewVersions"),
                hidden: true,
                name: "newversions",
                meta: {
                  title: "上传版本信息",
                  showCard: true,
                  parent: "versions",
                  cardTitle: "上传版本信息",
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});
